
import { mdiMinusCircleOutline, mdiPlusCircleOutline } from '@mdi/js'

import FaqMerchantAnswerExec from '@/components/ui/faq/FaqMerchantAnswerExec'

export default {
  components: { FaqMerchantAnswerExec },
  props: {
    elements: {
      type: Array,
      required: true
    },
    questionClass: {
      type: String,
      default: 'text-h6'
    },
    panelHeaderClass: {
      type: String,
      default: ''
    },
    panelContentClass: {
      type: String,
      default: 'text-left'
    },
    noWrapPadding: { type: Boolean, default: false }

  },
  data: () => {
    return {
      mdiMinusCircleOutline,
      mdiPlusCircleOutline
    }
  }

}
